import { Card, Col, Row } from 'react-bootstrap';
import type { SkillProposalDelivery, SkillProposalDeliveryState } from '../../apps/apis/claudeCodeDashboard/types';
import { DELIVERY_STATE_HELP, HELP_TEXT } from './agentTelemetryHelp';
import { HelpBadge, HelpLabel } from './HelpTooltip';

interface Props {
  delivery: SkillProposalDelivery;
}

const stateVariant = (state: SkillProposalDeliveryState) => {
  switch (state) {
    case 'applied':
      return 'success';
    case 'approved_pending_apply':
      return 'warning';
    case 'not_ready':
      return 'secondary';
  }
};

const formatDate = (value: string | null) => (value ? new Date(value).toLocaleString() : '-');

const SkillProposalDeliveryCard = ({ delivery }: Props) => (
  <Card className="mb-3">
    <Card.Body>
      <div className="d-flex justify-content-between align-items-start gap-2 mb-3">
        <div>
          <Card.Title className="h5 mb-1">
            <HelpLabel description={HELP_TEXT.deliveryLifecycle}>Delivery lifecycle</HelpLabel>
          </Card.Title>
          <div className="text-muted small">Local personal skill check/apply telemetry from employee machines.</div>
        </div>
        <HelpBadge bg={stateVariant(delivery.state)} description={DELIVERY_STATE_HELP[delivery.state]}>
          {delivery.state}
        </HelpBadge>
      </div>

      <Row className="g-2 small">
        <Col md={6}>
          <div className="text-muted">
            <HelpLabel description="Most recent local check for approved personal skill delivery.">
              Last checked
            </HelpLabel>
          </div>
          <div>{formatDate(delivery.lastCheckedAt)}</div>
        </Col>
        <Col md={6}>
          <div className="text-muted">
            <HelpLabel description="Most recent time the employee machine reported applying the skill.">
              Last applied
            </HelpLabel>
          </div>
          <div>{formatDate(delivery.lastAppliedAt)}</div>
        </Col>
        <Col md={6}>
          <div className="text-muted">
            <HelpLabel description="Generated proposal asset id observed during local apply.">Applied asset</HelpLabel>
          </div>
          <div>{delivery.appliedAssetId ?? '-'}</div>
        </Col>
        <Col md={6}>
          <div className="text-muted">
            <HelpLabel description="Skill id installed locally by the employee machine.">Applied skill</HelpLabel>
          </div>
          <div>{delivery.appliedSkillId ?? '-'}</div>
        </Col>
        <Col md={6}>
          <div className="text-muted">
            <HelpLabel description="Count of local delivery check telemetry events.">Check events</HelpLabel>
          </div>
          <div>{delivery.checkEventCount}</div>
        </Col>
        <Col md={6}>
          <div className="text-muted">
            <HelpLabel description="Count of local delivery apply telemetry events.">Apply events</HelpLabel>
          </div>
          <div>{delivery.appliedEventCount}</div>
        </Col>
      </Row>
    </Card.Body>
  </Card>
);

export default SkillProposalDeliveryCard;
